import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PlazzaService } from 'src/app/services/plazza.service';


@Component({
  selector: 'app-show-gurus',
  templateUrl: './show-gurus.component.html',
  styleUrls: ['./show-gurus.component.scss']
})
export class ShowGurusComponent implements OnInit {

  @Input('dispatchs') dispatchs: Array<any> = [];

  gurus:any = [
    { id: 481, img: "481.png", name: "Laura G. Rivera", description: "Ingeniera Industrial y Diseñadora Gráfica", rating: 0},
    { id: 615,  img: "615.png", name: "Angel G. Blandin", description: "Ingeniero Agroindustrial y Técnico en Computación", rating: 0},
    { id: 127,  img: "127.png", name: "Gabriela Martínez", description: "Consultora de Marketing", rating: 5 },
    { id: 628,  img: "628.png", name: "Edgar M. Diaz", description: "Ingeniero Ambiental", rating: 0},
  ]

  rating = 0;
  starCount = 5;
  ratingArr: boolean[] = []; // true = solid star; false = empty star

  snackBarDuration = 1000;
  response = [
    'You broke my heart!',
    'Really?',
    'We will do better next time.',
    'Glad you like it!',
    'Thank you so much!'
  ]
 

  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
    public plazzaService: PlazzaService
  ) { 
    // default to no rating, i.e. all empty stars
    this.ratingArr = Array(this.starCount).fill(false);
  }

  ngOnInit(): void {

  }

  openPage(){
    this.router.navigate(['/products']);
  }
  openGuru(){
    this.router.navigate(['/']);
  }

  returnStar(i: number) {
    if (this.rating >= i + 1) {
      return 'star';
    } else {
      return 'star_border';
    }
  }

  onClick(i: number) {
    this.rating = i + 1;
    this.snackBar.open(this.response[i], '', {
      duration: this.snackBarDuration,
      panelClass: ['snack-bar']
    });

  }

}
